import React from "react";

function SplashScreen() {
  return (
    <div className="splash-screen" role="status" aria-label="Loading VoiceTodo">
      <div className="splash-mark" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2.25"
            d="M19 11a7 7 0 01-14 0m7 7v4m-4 0h8m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z"
          />
        </svg>
      </div>
      <div className="splash-copy">
        <h1>VoiceTodo</h1>
        <p>Clear your mind. Plan your day.</p>
      </div>
      <div className="splash-loader" aria-hidden="true">
        <span />
      </div>
    </div>
  );
}

export default SplashScreen;
